import { render, staticRenderFns } from "./button-limited.vue?vue&type=template&id=4f904d9b&"
import script from "./button-limited.vue?vue&type=script&lang=js&"
export * from "./button-limited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports